var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _rect, _rect2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAccessMan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 99,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.28 93.559l17.46-24.56a19.623 19.623 0 0121.378-7.5l29.849 8.527a19.641 19.641 0 0110.72 7.668l4.004 15.865H27.28z",
    fill: "#CCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.076 67.843l-8.351-21.458-18.73 5.217 4.285 16.241c-2.25 2.4-2.554 6.037-1.03 8.423 3.725 5.834 14.421 0 19.124-4.211l4.702-4.212z",
    fill: "#FFCCBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.871 59.337L73.957 47 59.28 51.66l4.193 13.209c5.22.42 10.56-1.462 14.403-5.527l-.005-.005z",
    fill: "#EBA99A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.787 42.34c2.473-8.648-1.742-18.013-10.198-21.755l-2.982-1.322c-6.617-2.929-14.353.066-17.282 6.682l-6.123 13.839c-2.929 6.616-1.922 15.205 4.573 18.608l2.366 1.044c9.367 4.645 18.886-.134 24.195-6.328a6.03 6.03 0 004.805.53 6.048 6.048 0 003.972-7.579 6.028 6.028 0 00-3.327-3.724l.001.005z",
    fill: "#FFCCBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.138 41.621a6.003 6.003 0 014.415.326l1.182-2.672c5.626-10.237-.063-14.075-6.552-16.945l-7.974-3.527c-1.239-.547-14.324-5.853-14.324-5.853l-5.381 9.235 22.889 9.013-.45 2.768a7.922 7.922 0 001.113 5.493l.661 1.058-1.994 5.415c-.554 1.502.743 1.67 2.228 2.264a6.046 6.046 0 014.189-6.57l-.002-.005z",
    fill: "#515864"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.711 41.67c-.369.116-.752.201-1.149.246a6.32 6.32 0 01-4.695-1.32 6.339 6.339 0 01-2.387-4.255 6.32 6.32 0 011.32-4.696 6.34 6.34 0 014.255-2.386c3.487-.417 6.664 2.084 7.083 5.575a6.385 6.385 0 01-4.427 6.836zM55.18 30.407a5.397 5.397 0 00-2.638 1.822 5.376 5.376 0 00-1.123 3.997 5.4 5.4 0 002.031 3.625 5.4 5.4 0 003.998 1.127 5.431 5.431 0 004.747-6.032 5.433 5.433 0 00-7.02-4.537l.005-.002zM71.827 45.761a6.648 6.648 0 01-1.158.248 6.32 6.32 0 01-4.696-1.32 6.34 6.34 0 01-2.386-4.254 6.32 6.32 0 011.32-4.696 6.34 6.34 0 014.255-2.386 6.32 6.32 0 014.696 1.32 6.34 6.34 0 012.386 4.254 6.32 6.32 0 01-1.32 4.696 6.33 6.33 0 01-3.093 2.137l-.004.001zm-3.54-11.255a5.396 5.396 0 00-2.638 1.821 5.376 5.376 0 00-1.123 3.997 5.4 5.4 0 002.03 3.625 5.4 5.4 0 004 1.128 5.397 5.397 0 003.624-2.032 5.376 5.376 0 001.123-3.997 5.4 5.4 0 00-2.03-3.624 5.4 5.4 0 00-4-1.128c-.337.041-.667.11-.986.21z",
    fill: "#3A92E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.184 43.547a.485.485 0 01-.298-.005l-8.244-2.984a.472.472 0 01.32-.886l8.245 2.984a.472.472 0 01-.021.896l-.002-.005zM64.666 37.228a.468.468 0 01-.332-.02l-1.953-.857a.47.47 0 11.377-.864l1.953.857a.47.47 0 01-.047.88l.002.004z",
    fill: "#3A92E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.884 39.41c-.328.928-1.075 1.512-1.664 1.3-.59-.21-.803-1.132-.475-2.06.327-.927 1.074-1.51 1.664-1.3.59.211.803 1.133.475 2.06zM61.215 36.191c-.328.928-1.075 1.512-1.665 1.3-.59-.21-.803-1.132-.475-2.06.328-.927 1.075-1.51 1.664-1.3.59.212.803 1.133.476 2.06zM61.45 46.201c1.567-.17 2.858.758 3.423 1.422a.474.474 0 01-.72.614c-.071-.082-1.667-1.897-3.736-.714a.472.472 0 01-.645-.177.468.468 0 01.177-.645 3.85 3.85 0 011.497-.5h.005zM51.086 11.517C51.176 5.157 56.399.07 62.753.159c6.354.088 11.432 5.315 11.342 11.676-.09 6.36-5.313 11.445-11.667 11.357-6.354-.088-11.432-5.315-11.342-11.675z",
    fill: "#515864"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.645 5.525l36.076 15.34-7.004 16.494L57.642 22.02l7.003-16.495z",
    fill: "#515864"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 27.28,
    cy: 75,
    r: 24,
    fill: "#D0021B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.65 64.988a3.116 3.116 0 00-4.375 0 3.088 3.088 0 000 4.367l5.688 5.656-5.666 5.634a3.088 3.088 0 000 4.367 3.116 3.116 0 004.376 0l5.673-5.642 5.563 5.532a3.116 3.116 0 004.376 0 3.088 3.088 0 000-4.367l-5.555-5.524 5.555-5.525a3.088 3.088 0 000-4.367 3.118 3.118 0 00-4.376 0l-5.582 5.513-5.676-5.644z",
    fill: "#fff"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.28,
    y: 20,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#F7C1C8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.063,
    y: 27,
    width: 25,
    height: 5,
    rx: 2.5,
    fill: "#FBDBDF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 106.78,
    cy: 59.5,
    r: 3.5,
    fill: "#E64D5F"
  })));
}
export default SvgNoAccessMan;